import React from 'react'
import '../Styles/error404.css'
import {Link} from 'react-router-dom'

const Error404 = () => {
  return (
      <>
        <div className="errorSite">
            <img alt='logo_error' src='./img/milaLogo.png'/>
            <h1>Error404 - Pagina no encontrada :( </h1>
            <Link to="/" className="error_regresar"><h1 >Regresar</h1></Link>
        </div>
            
        

      </>
    
  )
}

export default Error404